import React from 'react';
import { Target, TrendingUp, Shield, Zap } from 'lucide-react';

export const WelcomeStep: React.FC = () => {
  const features = [
    {
      icon: <Target className="w-6 h-6 text-blue-600" />,
      title: 'Control de Presupuestos',
      description: 'Establece límites por categoría y recibe alertas cuando te acerques a ellos'
    },
    {
      icon: <TrendingUp className="w-6 h-6 text-green-600" />,
      title: 'Seguimiento de Gastos',
      description: 'Registra y categoriza todos tus gastos para entender mejor tus hábitos'
    },
    {
      icon: <Shield className="w-6 h-6 text-purple-600" />,
      title: 'Datos Seguros',
      description: 'Tu información se guarda localmente en tu dispositivo de forma segura'
    },
    {
      icon: <Zap className="w-6 h-6 text-yellow-600" />,
      title: 'Insights Inteligentes',
      description: 'Obtén recomendaciones personalizadas basadas en tus patrones de gasto'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h4 className="text-lg font-semibold text-gray-900 mb-2">
          ¿Qué puedes hacer con Invirtiendo?
        </h4>
        <p className="text-gray-600">
          Te ayudamos a gestionar tus finanzas personales de manera simple y efectiva
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {features.map((feature, index) => (
          <div
            key={index}
            className="flex items-start space-x-3 p-4 bg-white rounded-lg border border-gray-200"
          >
            <div className="flex-shrink-0">
              {feature.icon}
            </div>
            <div>
              <h5 className="font-medium text-gray-900 mb-1">
                {feature.title}
              </h5>
              <p className="text-sm text-gray-600">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-center space-x-2 mb-2">
          <Shield className="w-5 h-5 text-blue-600" />
          <h5 className="font-medium text-blue-900">Privacidad garantizada</h5>
        </div>
        <p className="text-sm text-blue-800">
          Todos tus datos financieros se almacenan únicamente en tu dispositivo. 
          No enviamos información personal a ningún servidor externo.
        </p>
      </div>

      <div className="text-center">
        <p className="text-sm text-gray-500">
          El proceso de configuración toma solo unos minutos
        </p>
      </div>
    </div>
  );
};